export default __webpack_public_path__ + "static/media/locks-of-love-logo.631a930d.png";